import { ENV } from '../environment/environment';
import { ENV_VN } from '../environment/environment.vn';

if (typeof window !== 'undefined') {
  if (window.location.origin.includes('vnbizbox.com')) {
    Object.assign(ENV, ENV_VN);
  }
  
}

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app.module';

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/app/main.ts